export function init() {
	var Popup = (function () {

		// Local variables
		// s == settings
		var s = {},
			isExitPopupShown = false,
			previousY = 0,
			isPopupVisible = false;

		var close = function() {
			s.popupEl.addClass('visuallyhidden');

			isPopupVisible = false;
		};

		var show = function() {
			// If another popup is already visible - don't show the next one
			if (!isPopupVisible) {

				// Show the popup
				s.popupEl.removeClass('visuallyhidden');

				isPopupVisible = true;
				// setCookie();
				localStorage.setItem('visited', (new Date()).getDate());
			}
		};

		var init = function(config) {
			s = config;

			// Handle popup close events

			// On "x" click
			s.closeEl.on('click', close);

			// But do nothing when clicked inside popup
			s.popupEl.on('click', function (e) {
				e.stopPropagation();
			});

			// if(localStorage.getItem('visited') != (new Date()).getDate()) {
				$(document).on('mousemove', function (e) {
					if (e.pageY - $(document).scrollTop() <= 20 && previousY > e.pageY && !isExitPopupShown) {
						show();
						isExitPopupShown = true;
					}

					previousY = e.pageY;
				});
			// }
		};

		return {
			init: init
		};

	})();

	Popup.init({
		popupEl: $('.popup-hld'),
		closeEl: $('.popup-hld').find('.close-btn')
	});
}
